// alterado - revisado

import React  from 'react'

import HARDCODE from '../../../business-const/HardCode/HardCode'

import LABEL from '../../../business-const/Label/Label'

import {
    CLASSNAME
} from '../../../business-const/Style/Style'

import {
    tituloCliente,
    tituloConjuge,
} from '../cliente-form/ClienteService'

import {
    GridContainer,
    GridItem12,
} from '../../../business-components/Grid/Grid'

import {
    formataValor
} from '../../../business-components/Formata/Formata'

import {
    dadosCompletosCliente,
    dadosCompletosConjuge,
} from '../cliente-form/ClienteService'

import {
    formataTempoCobertura,
} from '../estudo-form/EstudoService'



const EstudoFormPanel = ({ values, panelValores, tipoPanel }) => {

    return (
        panelValores && (
            <GridContainer>
                <GridItem12
                    style={{
                        display: 
                            dadosCompletosCliente(values)
                                ? "block"
                                : "none"
                    }} 
                >
                    <h3
                        className={CLASSNAME().valorReceitaDespesaClienteTitulo}
                    >
                        {tituloCliente(values)}
                    </h3>
                    <h3
                        className={CLASSNAME().valorReceitaDespesaCliente}
                    >
                        {formataValor((
                            tipoPanel === HARDCODE.tipoPanelGarantiasAtuais
                                ?
                                    panelValores.valorReceitaClientePainel
                                :
                                    panelValores.valorDespesaClientePainel
                        ), 2)}
                    </h3>
                </GridItem12>

                <GridItem12
                    style={{
                        display: 
                            dadosCompletosConjuge(values)
                                ? "block"
                                : "none"
                    }} 
                >
                    <h3
                        className={CLASSNAME().valorReceitaDespesaConjugeTitulo}
                    >
                        {tituloConjuge(values)}
                    </h3>
                    <h3
                        className={CLASSNAME().valorReceitaDespesaConjuge}
                    >
                        {formataValor((
                            tipoPanel === HARDCODE.tipoPanelGarantiasAtuais
                                ?
                                    panelValores.valorReceitaConjugePainel
                                :
                                    panelValores.valorDespesaConjugePainel
                        ), 2)}
                    </h3>
                </GridItem12>
                
                {tipoPanel === HARDCODE.tipoPanelDespesasTotais
                    ? 
                        <GridItem12>
                            <h3
                                className={CLASSNAME().anosProtegerProtegidoTitulo}
                            >
                                {LABEL.anosProteger}
                            </h3>
                            <h3
                                className={CLASSNAME().anosProtegerProtegido}
                            >
                                {formataTempoCobertura(panelValores.anosProtegerProtegido)}
                            </h3>
                        </GridItem12>
                    :
                        ''
                }
            </GridContainer>
        )
    )
}

export default EstudoFormPanel